// @ts-nocheck
// @ts-ignore
import { React, createRef } from "react";
import ApplyJbSavedIn from "../fields/applyJbSavedIn";
import { dataStatus, procedureJbStatus, savedInRadioValues } from "../../../publicDictionaryValues";
import downloadIcon from "../../../../assets/image/downloadIcon.png";
import ApplyJbClientServerPath from "../fields/applyJbClientServerPath";
import styles from "../index.module.scss";
import "./approve.scss";
import NormalModal, { ModalWithComponent } from "../../../../base/basicComponents/modal";
import ApproveApplyJbTable from "../../procedureFileSections/fields/procedureFileTableFields/approveApplyJbFileTable";
import InputLabel from "../../../../base/basicComponents/inputLabel";
import AppSetting from "../../../../config/AppSetting";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import BaseApplyForJbSection from "../baseApplyForJbSection";
import { ApplyJBTag } from "../../../../base/basicComponents/status";
import { ApplyJBTags } from "../../../../base/basicComponents/status/types";
const procedureServerPathRef = createRef();
const modalRef = createRef();
const procedureReplaceFileRef = createRef();
const procedureReturnAddFileRef = createRef();

class ApplyForJbApproveSection extends BaseApplyForJbSection {
  constructor(props: any) {
    super(props);

    this.state = {
      clientServerPathReturnReason: this.props.rejectReason,
      isServerPathReturnBtnDisabled: false,
      isServerPathApproveBtnDisabled: false,
      isServerPathReturned: false,
      serverPathReturnReasonInputValue: "",
      isModalOpen: false,
      downloadBtnDisabled: true,
      downloadIcon: downloadIcon,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      modalState: {
        isModalWithComponentOpen: false,
        closable: false,
        okText: "",
        cancelText: "",
        modalTitle: "",
        handleOk: null,
        handleCancel: null,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
        isShowTextArea: false,
        textAreaPlacement: "",
        textAreaMaxLength: 1000,
        isShowSelect: false,
        isShowTextAreaAndUploadDragger: false,
        isShowReadOnlyRichTextEditor: false,
        uploadDraggerFileType: "",
        rowIndex: 0,
        fileIds: [],
        fileNames: [],
        modalWidth: 900,
        isTableBorderError: this.props.isTableBorderError,
      },
      procedureFileTableState: {
        fileTableReasonStatus: "",
        isTableBorderError: false,
        fileTableReturnReasonValue: "",
        isChange: false,
      },
    };

    // @ts-ignore
    this.isShowDragger = false;
    // @ts-ignore
    this.fileTableRef = createRef();
    // @ts-ignore
    this.files = [];
  }

  getServerPathOffset = () => {
    // @ts-ignore
    return procedureServerPathRef.current.offsetTop;
  };

  setServerPathError = () => {
    // @ts-ignore
    procedureServerPathRef.current.setServerPathError();
  };

  getServerPathStatus = () => {
    if (procedureServerPathRef.current === null || procedureServerPathRef.current === undefined) {
      return "";
    }

    // @ts-ignore
    return procedureServerPathRef.current.state.serverPathSectionState.serverPathStatus;
  };

  getServerPathReturnReasonValue = () => {
    if (procedureServerPathRef.current === null || procedureServerPathRef.current === undefined) {
      return "";
    }

    // @ts-ignore
    return procedureServerPathRef.current.state.serverPathSectionState.serverPathReturnReasonValue;
  };

  updateDataList = (dataList: any) => {
    // @ts-ignore
    this.fileTableRef.current.updateDataList(dataList);
  };

  initDataList = () => {
    // @ts-ignore
    if (this.fileTableRef.current === null) {
      return;
    }
    const dataList = this.props.procedureFileData;
    // @ts-ignore
    this.fileTableRef.current.updateDataList(dataList);
  };

  getDataList = () => {
    // @ts-ignore
    if (this.fileTableRef.current === null) {
      return;
    }
    // @ts-ignore
    const dataList = JSON.parse(JSON.stringify(this.fileTableRef.current.state.data));

    return dataList;
  };

  handleJbProcedureSavedValue = (procedureJbStatusId: any) => {
    if (procedureJbStatusId === null) {
      return null;
    }

    // @ts-ignore
    return procedureJbStatus[procedureJbStatusId];
  };

  handleProcedureFileTableApproveAfterReturnOkClick = () => {
    // @ts-ignore
    const index = this.procedureFileCurrentRowIndex;
    const procedureFileData = this.getDataList();
    this.handleApplyForJbApprovePendingProcedureFileNoReturnApprove(procedureFileData, index);
  };

  handleProcedureFileTableApproveCancelClick = () => {
    this.hideModal();
  };

  handleApprovedAfterReturned = (type: any) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: true,
        modalLabel: (
          <span className={styles.modalText}>
            Are you sure to change the selection? Your Reject Reason and Attachment will be cleared.
          </span>
        ),
        okText: "Confirm",
        isShowTextArea: false,
        modalTitle: null,
        actionType: type,
        closable: false,
        modalWidth: 520,
        centered: false,
        handleOk: this.handleProcedureFileTableApproveAfterReturnOkClick,
        handleCancel: this.handleProcedureFileTableApproveCancelClick,
      },
    });
  };

  handleApplyForJbApprovePendingProcedureFileNoReturnApprove = (
    procedureFileData: any,
    value: any
  ) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        modalWidth: 520,
      },
    });
    procedureFileData[value].isRejected = false;
    procedureFileData[value].data.find((item: any) => item.name === "status").value =
      dataStatus.approval;
    procedureFileData[value].data.find((item: any) => item.name === "attachment").fileId = null;
    procedureFileData[value].data.find((item: any) => item.name === "attachmentFileID").value =
      null;
    procedureFileData[value].data.find((item: any) => item.name === "rejectReason").value = null;
    procedureFileData[value].data.find((item: any) => item.name === "rejectReason").isDisabled =
      true;
    procedureFileData[value].data.find((item: any) => item.name === "attachment").value = null;
    procedureFileData[value].data.find((item: any) => item.name === "attachment").isDisabled = true;

    procedureFileData[value].isApproveDisabled = true;
    procedureFileData[value].isReturnDisabled = false;
    procedureFileData[value].isError = false;
    // @ts-ignore
    this.fileTableRef.current.updateDataList(procedureFileData);
    this.hideModal();
  };

  hideModal = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: false,
        modalLabel: "",
        handleOk: null,
        handleCancel: null,
        isShowSelect: false,
        okText: "",
        cancelText: "",
        modalTitle: "",
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
        isShowTextArea: false,
        textAreaPlacement: "",
        isShowTextAreaAndUploadDragger: false,
      },
    });
  };

  handleFileApprovedClick = (value: any) => {
    // @ts-ignore
    this.procedureFileCurrentRowIndex = value;
    const procedureFileData = this.getDataList();
    if (procedureFileData[value].isRejected) {
      // @ts-ignore
      this.handleApprovedAfterReturned();
    } else {
      this.handleApplyForJbApprovePendingProcedureFileNoReturnApprove(procedureFileData, value);
    }
  };

  setReturnReasonValue = (tableDataList: any, index: any, returnValue: any) => {
    tableDataList[index].data.find((item: any) => item.name === "status").value = dataStatus.reject;
    tableDataList[index].data.find((item: any) => item.name === "rejectReason").value = returnValue;

    // @ts-ignore
    const plainText = modalRef.current.tinyMceEditor.getContent({
      format: "text",
    });
    tableDataList[index].data.find((item: any) => item.name === "rejectReason").plainText =
      plainText;

    tableDataList[index].data.find((item: any) => item.name === "rejectReason").isDisabled = false;
    // @ts-ignore
    tableDataList[index].data.find((item: any) => item.name === "attachment").fileList =
      procedureReturnAddFileRef.current.state.fileList;
    this.setState({
      procedureFileTableState: {
        fileTableReturnReasonValue: null,
        fileTableReasonStatus: null,
      },
    });
    // @ts-ignore
    modalRef.current.setRichTextValue(null);
  };

  handleFileDelete = (tableDataList: any, index: any) => {
    tableDataList[index].data.find((item: any) => item.name === "attachment").fileId = null;
    tableDataList[index].data.find((item: any) => item.name === "attachment").value = null;
    tableDataList[index].data.find((item: any) => item.name === "attachmentFileID").value = null;
  };

  handleProcedureFileTableReturnOkClick = () => {
    const fileTableReturnValue = this.state.procedureFileTableState.fileTableReturnReasonValue;
    let returnValue =
      fileTableReturnValue !== null ? fileTableReturnValue.trim() : fileTableReturnValue;
    const tableDataList = this.getDataList();
    // @ts-ignore
    const index = this.procedureFileCurrentRowIndex;
    // @ts-ignore
    const files = procedureReturnAddFileRef.current.state.fileList;
    // @ts-ignore
    const fileIds = procedureReturnAddFileRef.current.state.fileIdList;
    if (
      returnValue !== null &&
      returnValue &&
      this.richTextEditorValueNotEmpty(modalRef.current?.tinyMceEditor)
    ) {
      this.hideModal();
      if (files.length === 0) {
        this.handleFileDelete(tableDataList, index);
      }
      tableDataList[index].isRejected = true;
      if (files.length > 0) {
        files.forEach((item: any, i: any) => {
          this.setReturnReasonValue(tableDataList, index, returnValue);
          tableDataList[index].data.find((dataItem: any) => dataItem.name === "attachment").value =
            item.name;
          tableDataList[index].data.find(
            (dataItem: any) => dataItem.name === "attachmentFileID"
          ).value = fileIds[i];
          tableDataList[index].data.find((dataItem: any) => dataItem.name === "attachment").fileId =
            fileIds[i];
          tableDataList[index].isApproveDisabled = false;
          tableDataList[index].isReturnDisabled = true;
          tableDataList[index].isReturned = true;
          tableDataList[index].isError = false;
          this.setState({
            procedureFileTableState: {
              fileTableReturnReasonValue: null,
              fileTableReasonStatus: null,
            },
          });
          // @ts-ignore
          modalRef.current.setRichTextValue(null);
          // @ts-ignore
          procedureReturnAddFileRef.current.clearFileAttach();
        });
      } else {
        this.setReturnReasonValue(tableDataList, index, returnValue);
        tableDataList[index].isApproveDisabled = false;
        tableDataList[index].isReturnDisabled = true;
        tableDataList[index].isRejected = true;
        tableDataList[index].isError = false;
      }
      // @ts-ignore
      this.fileTableRef.current.updateDataList(tableDataList);
    } else {
      this.setState({
        procedureFileTableState: {
          ...this.state.procedureFileTableState,
          fileTableReasonStatus: "error",
        },
      });

      const allToxTinymceElements = document.querySelectorAll(".tox-tinymce");

      allToxTinymceElements.forEach((element) => {
        // @ts-ignore
        element.style.border = "2px solid red";
      });
    }
  };

  handleProcedureFileTableReturnCancelComfirm = () => {
    // @ts-ignore
    procedureReturnAddFileRef.current.clearFileAttach();
    const tableDataList = this.getDataList();
    // @ts-ignore
    this.fileTableRef.current.updateDataList(tableDataList);
    this.hideModal();
    this.setState({
      procedureFileTableState: {
        ...this.state.procedureFileTableState,
        fileTableReturnReasonValue: null,
        fileTableReasonStatus: null,
      },
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        // thre is a empty function
      },
    });

    const allToxTinymceElements = document.querySelectorAll(".tox-tinymce");

    allToxTinymceElements.forEach((element) => {
      // @ts-ignore
      element.style.border = "2px solid #eee";
    });

    // @ts-ignore
    modalRef.current.setRichTextValue(null);
  };

  handleProcedureFileTableReturnCancelClick = () => {
    this.setState({
      isModalOpen: true,
      modalChildContent: "Are you sure to quit without saving?",
      handleModalConfirm: this.handleProcedureFileTableReturnCancelComfirm,
    });
  };

  handleApplyForJbApprovePendingSetReturnModal = (value: any) => {
    const procedureFileData = this.getDataList();
    const fileName = procedureFileData[value].data.find(
      (item: any) => item.name === "attachment"
    ).value;
    const fileId = procedureFileData[value].data.find(
      (item: any) => item.name === "attachmentFileID"
    ).value;
    const fileNames = fileName == null ? [] : [fileName];
    const fileIds = fileId == null ? [] : [fileId];
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: true,
        isShowTextAreaAndUploadDragger: true,
        uploadDraggerFileType: "text",
        okText: "Confirm",
        closable: false,
        fileIds: fileIds,
        fileNames: fileNames,
        modalWidth: 900,
        modalTitle: <span className="fs-18">Reason for Rejection</span>,
        modalLabel: (
          <InputLabel
            text="Please fill in the reason for rejection"
            required={true}
            className={styles.modalText}
          />
        ),
        // @ts-ignore
        textAreaPlacement: this.returnModalInputPlacement,
        rowIndex: value,
        isShowTextArea: true,
        centered: true,
        handleOk: this.handleProcedureFileTableReturnOkClick,
        handleCancel: this.handleProcedureFileTableReturnCancelClick,
      },
    });
  };

  handleFileRejectClick = (value: any, isReadOnlyMode = false) => {
    // @ts-ignore
    this.isShowDragger = !this.isShowDragger;
    const procedureFileData = this.getDataList();
    const returnReasonValue = procedureFileData[value].data.find(
      (item: any) => item.name === "rejectReason"
    ).value;
    this.setState({
      procedureFileTableState: {
        ...this.state.procedureFileTableState,
        fileTableReturnReasonValue: returnReasonValue,
      },
    });
    // @ts-ignore
    modalRef.current.setRichTextValue(returnReasonValue);
    // @ts-ignore
    this.procedureFileCurrentRowIndex = value;
    if (isReadOnlyMode) {
      const lastTemplate = { ...this.state.modalState };
      const closeModalFn = () =>
        this.setState({
          modalState: {
            ...lastTemplate,
            isModalWithComponentOpen: false,
            isShowReadOnlyRichTextEditor: false,
          },
        });
      this.setState({
        modalState: {
          ...this.state.modalState,
          isShowReadOnlyRichTextEditor: true,
          isModalWithComponentOpen: true,

          isShowTextAreaAndUploadDragger: false,
          closable: true,
          modalWidth: 900,
          modalTitle: <span className="fs-18">Reason for Rejection</span>,
          modalLabel: "",
          rowIndex: value,
          isShowTextArea: false,
          centered: true,

          handleOk: closeModalFn,
          handleCancel: closeModalFn,
        },
      });
    } else {
      this.handleApplyForJbApprovePendingSetReturnModal(value);
    }
  };

  handleSetServerPathReturnReasonValue = (content: any, editor: any) => {
    this.setState({
      procedureFileTableState: {
        ...this.state.procedureFileTableState,
        fileTableReturnReasonValue: content,
        fileTableReasonStatus: null,
      },
    });

    const allToxTinymceElements = document.querySelectorAll(".tox-tinymce");
    allToxTinymceElements.forEach((element) => {
      // @ts-ignore
      element.style.border = "2px solid #eee";
    });
  };

  getAddFileDto = (item: any) => {
    return {
      FileName: item.name,
      ContainerName: AppSetting.urlPrefix.addFile.ContainerName,
      AccountName: AppSetting.urlPrefix.addFile.AzureAccountName,
      ProductKey: AppSetting.urlPrefix.addFile.ProductKey,
      FolderName: AppSetting.urlPrefix.addFile.ProcedureFileFolder,
    };
  };

  uploadFileOnSuccess = (result: any, returnPara: any) => {
    returnPara.callback(returnPara.fileName, { text: returnPara.fileName });
    // @ts-ignore
    this.files.unshift({
      fileId: result.storageFileID,
      fileName: returnPara.fileName,
    });
  };

  uploadFileOnError = () => {
    this._alertError("Upload Fail");
  };

  uploadApplyForJbApprovePendingFile = (e: any, callback: any) => {
    let file = e.files[0];
    let fileForm = new FormData();
    let addFileDto = this.getAddFileDto(file);
    fileForm.append("formFile", file);
    fileForm.append("addFileDto", JSON.stringify(addFileDto));
    let returnPara = {
      fileName: file.name,
      callback: callback,
    };

    ProcedureDetailService.addFile(
      fileForm,
      this.uploadFileOnSuccess,
      this.uploadFileOnError,
      returnPara
    );
  };

  handleApplyForJbApprovePendingUploadFile = (callback: any, value: any, meta: any) => {
    let input = document.createElement("input");
    input.setAttribute("type", "file");
    input.click();
    input.onchange = (e) => this.uploadApplyForJbApprovePendingFile(e.target, callback);
  };

  _hideModalBtnsDisabled = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
      },
    });
  };

  _openModalBtnsDisabled = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isOkBtnDisabled: true,
        isCancelBtnDisabled: true,
      },
    });
  };

  hideActionButton = (record: any) => {
    const applyForValue = record.data.find((item: any) => item.name === "applyfor").value;
    if (applyForValue === "JB") {
      return false;
    }
    return true;
  };

  hideNormalModal = () => {
    this.setState({
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        // thre is a empty function
      },
    });
  };

  componentDidMount() {
    this.initDataList();
  }

  handleApplyForJbApprovePendingColumn = () => {
    return [
      {
        name: "ProcedureId",
        dataName: "procedureId",
        type: "text",
        isShow: false,
      },
      {
        name: "checkbox",
        dataName: "checkbox",
        type: "checkbox",
        isShow: true,
        check: this._check,
        onCheck: this._onCheck,
        headCheck: this._headCheck,
        headOnCheck: this._headOnCheck,
      },
      {
        name: "File Name",
        dataName: "fileName",
        type: "fileName",
        isShow: true,
        isDisabled: false,
      },
      {
        name: "Uploaded Date",
        dataName: "uploadedDate",
        type: "text",
        isShow: true,
      },
      {
        name: "Uploaded By",
        dataName: "uploadByName",
        type: "text",
        isShow: true,
      },
      {
        name: "Approval Date",
        dataName: "approveDate",
        type: "text",
        isShow: true,
      },
      {
        name: "Status",
        dataName: "status",
        type: "tag",
        isShow: true,
      },
      {
        name: "JB Procedure",
        dataName: "jbProcedure",
        type: "text",
        isShow: true,
      },
      {
        name: "Apply for?",
        dataName: "applyfor",
        type: "select",
        isShow: true,
        isDisabled: true,
        // onChange: this.applyForOnChange,
      },
      {
        name: "Reject Reason",
        dataName: "rejectReason",
        type: "input",
        isShow: true,
        showEdit: true,
      },
      {
        name: "Attachment",
        dataName: "attachment",
        type: "link",
        isShow: true,
        showEdit: true,
      },
      {
        name: "Action",
        dataName: "action",
        type: "button",
        isApproveDisabled: false,
        isReturnDisabled: false,
        approveText: "Approve",
        returnText: "Reject",
        approveColor: "blue",
        returnColor: "red",
        onApproveClick: this.handleFileApprovedClick,
        onReturnClick: this.handleFileRejectClick,
        hideActionButton: this.hideActionButton,
        isShow: true,
        approveButtonTestid: "apply-jb-approve-btn",
        rejectButtonTestid: "apply-jb-reject-btn",
      },
    ];
  };

  handleApplyForJbApprovePendingApproveApplyJbTable = () => {
    const columns = this.handleApplyForJbApprovePendingColumn();

    return (
      <div className={`${styles.downloadButtonDiv} applyJbTable`}>
        {/* @ts-ignore */}
        <ApproveApplyJbTable
          ref={(this as any).fileTableRef}
          columns={columns}
          procedureNoteMaxLength={1000}
          fileSectionDisabled={false}
          procedureNoteSize="small"
          inputOnChange={(this as any).inputOnChange}
          hasSubmit={false}
          isScrollData={false}
          fileTableRef={(this as any).fileTableRef}
          className="procedureFiles"
          isShowTotalFileNum={true}
          isSupportingFile={false}
          isShowExpendIcon={false}
          handleReturnClick={(e: any, isReadOnlyMode: any) =>
            this.handleFileRejectClick(e.target.attributes.rowindex.value, isReadOnlyMode)
          }
          downloadFile={this.downloadFile}
        />
      </div>
    );
  };

  render() {
    const {
      savedInRadioValue,
      procedureJbStatusId,
      serverPathValue,
      applyfor,
      isUpdateClientServerPath,
      isUpdateProcedureSavedIn,
    } = this.props;
    const {
      clientServerPathReturnReason,
      isServerPathReturnBtnDisabled,
      isServerPathApproveBtnDisabled,
      isServerPathReturned,
      serverPathReturnReasonInputValue,
      isModalOpen,
      modalChildContent,
      handleModalConfirm,
      downloadBtnDisabled,
    } = this.state;

    const {
      okText,
      cancelText,
      modalTitle,
      closable,
      isOkBtnDisabled,
      isCancelBtnDisabled,
      isModalWithComponentOpen,
      modalLabel,
      textAreaPlacement,
      textAreaMaxLength,
      isShowTextArea,
      isShowReadOnlyRichTextEditor,
      rowIndex,
      fileIds,
      fileNames,
      uploadDraggerFileType,
      modalWidth,
      handleOk,
      handleCancel,
      centered,
    } = this.state.modalState;
    const { fileTableReasonStatus, fileTableReturnReasonValue } =
      this.state.procedureFileTableState;

    return (
      <div className={styles.applyJbSectionsDiv}>
        <div className={styles.applyJbSectionTop}>
          <span className={`${styles.applyJbSectionTitle} fs-18`}>Procedure Files</span>
        </div>
        <div className={styles.topDiv}>
          <div className={styles.savedInDiv}>
            <ApplyJbSavedIn
              savedInRadioValue={savedInRadioValue}
              saveInTag={isUpdateProcedureSavedIn && <ApplyJBTag type={ApplyJBTags.Updated} />}
            />
          </div>
          {savedInRadioValue !== savedInRadioValues.systemOnly && (
            <div className={styles.clientPathDiv} data-highlight-id="ClientServerPathType1">
              {/* @ts-ignore */}
              <ApplyJbClientServerPath
                clientServerPathReturnReason={clientServerPathReturnReason}
                isServerPathReturnBtnDisabled={isServerPathReturnBtnDisabled}
                isServerPathApproveBtnDisabled={isServerPathApproveBtnDisabled}
                serverPathReturnReasonInputValue={serverPathReturnReasonInputValue}
                isServerPathReturned={isServerPathReturned}
                ref={procedureServerPathRef}
                serverPathValue={serverPathValue}
                procedureJbStatusId={procedureJbStatusId}
                applyForValue={applyfor}
                serverPathTag={
                  isUpdateClientServerPath && <ApplyJBTag type={ApplyJBTags.Updated} />
                }
              />
            </div>
          )}
        </div>

        {savedInRadioValue !== savedInRadioValues.serverOnly && (
          <>
            {this.handleApplyForJbSectionDownloadButton(downloadBtnDisabled)}
            {this.handleApplyForJbApprovePendingApproveApplyJbTable()}
          </>
        )}
        <div>
          {/* @ts-ignore */}
          <ModalWithComponent
            ref={modalRef}
            isModalOpen={isModalWithComponentOpen}
            closable={closable}
            okText={okText}
            cancelText={cancelText}
            title={modalTitle}
            className={styles.approvePageModal}
            handleOk={handleOk}
            handleCancel={handleCancel}
            isOkDisabled={isOkBtnDisabled}
            isCancelDisabled={isCancelBtnDisabled}
            isShowRichTextEditor={isShowTextArea}
            isShowRichTextEditorUploadDragger={isShowTextArea}
            isShowReadOnlyRichTextEditor={isShowReadOnlyRichTextEditor}
            richTextEditorUploadDraggerLabel={
              <InputLabel text="Attach Documents" className={styles.modalText} />
            }
            richTextValue={fileTableReturnReasonValue}
            handleEditorChange={this.handleSetServerPathReturnReasonValue}
            handleUploadFile={this.handleApplyForJbApprovePendingUploadFile}
            textAreaPlacement={textAreaPlacement}
            textAreaMaxLength={textAreaMaxLength}
            textAreaStatus={fileTableReasonStatus}
            label={modalLabel}
            modalWidth={modalWidth}
            fileUploadRef={procedureReplaceFileRef}
            fileUploadInputRef={procedureReturnAddFileRef}
            rowindex={rowIndex}
            fileIds={fileIds}
            fileNames={fileNames}
            isShowInnerDragger={(this as any).isShowDragger}
            isMultiple={false}
            isShowDeleteBtn={true}
            hideLoading={this._hideModalBtnsDisabled}
            openLoading={this._openModalBtnsDisabled}
            isLoading={isOkBtnDisabled}
            uploadDraggerFileType={uploadDraggerFileType}
            centered={centered}
            testid="apply-jb-reject-modal"
            okButtonTestid="apply-jb-reject-confirm-btn"
            cancelButtonTestid="apply-jb-reject-cancel-btn"
          />
        </div>
        <NormalModal
          okText="Confirm"
          cancelText="Cancel"
          childContent={<p className="fs-16">{modalChildContent}</p>}
          isModalOpen={isModalOpen}
          handleOk={handleModalConfirm}
          handleCancel={this.hideNormalModal}
          testid="apply-jb-approve-confirm-modal"
        />
      </div>
    );
  }
}

export default ApplyForJbApproveSection;
